
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetobhimashankar() {



    const cardData =
    {
        keyword: ' Pune to Bhimashankar Cab',
        heading: 'Prince Cabs: Pune to Bhimashankar Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Bhimashankar Cab services, ideal for pilgrimage tours, family travel, weekend trips, and spiritual getaways. Our well-maintained fleet of sedans, SUVs, and luxury cars ensures a comfortable and safe ride through the scenic ghats leading to the famous Bhimashankar Jyotirlinga temple. With experienced drivers, on-time pickups, and flexible travel plans, we make your Pune to Bhimashankar journey smooth and stress-free. Enjoy a hassle-free and affordable travel experience with Prince Cabs’ trusted cab service from Pune to Bhimashankar.',

        top: 'Top Places to Visit in Bhimashankar with Prince Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "The Bhimashankar Temple is one of the 12 sacred Jyotirlingas dedicated to Lord Shiva, making it a major pilgrimage site in Maharashtra. Nestled in the Sahyadri hills, the temple combines ancient Nagara-style architecture with a deeply spiritual atmosphere. Devotees from across India visit to seek blessings, especially during Mahashivratri. The temple is surrounded by lush greenery, enhancing its divine charm. Its legends are connected to Lord Shiva’s victory over the demon Tripurasura. Visiting this temple is both a religious and cultural experience."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is a haven for nature lovers, covering dense forests in the Western Ghats. It is home to the endangered Indian Giant Squirrel, locally known as ‘Shekru,’ and over 200 species of birds. The sanctuary is also rich in medicinal plants, streams, and waterfalls. Adventure seekers enjoy trekking through its lush trails. During monsoon, the forest transforms into a green paradise. It’s a perfect spot for eco-tourism, bird watching, and reconnecting with nature."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden shrine located deep in the forest, accessible only through a trek. The site is believed to house a naturally formed Shiva Lingam, making it a sacred spot for devotees. The journey to Gupt Bhimashankar is filled with scenic views, waterfalls, and dense greenery. Its untouched beauty gives visitors a sense of peace and mystery. This spot is less crowded, ideal for meditation and spiritual seekers. The trek itself is an adventure for those who love exploring hidden gems."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a calm and picturesque water body located near Bhimashankar Temple. It is believed to be blessed by Lord Hanuman and is surrounded by serene landscapes. The lake attracts migratory birds and is a great place for bird watching. Picnics and leisurely walks around the lake are popular among visitors. The area is less commercialized, offering a quiet escape into nature. Its spiritual connection and natural beauty make it a soothing stop during Bhimashankar visits."
  },
  {
    "title": "Nagphani Point (Duke’s Nose)",
    "description": "Nagphani Point, also known as Duke’s Nose due to its unique shape, offers a panoramic view of the Sahyadri ranges. Located near Bhimashankar, it is a favorite among trekkers and adventure seekers. The climb to the point is thrilling, with steep paths and rocky terrain. Once at the top, the view of valleys, waterfalls, and surrounding hills is breathtaking. It is especially popular at sunrise and sunset. This spot is a must-visit for trekking enthusiasts and photographers."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a scenic mountain pass near Bhimashankar that connects the plateau to the Konkan region. It offers stunning views of deep valleys, thick forests, and the Western Ghats. Trekkers and bikers love exploring this route due to its adventurous trails. During monsoon, the area is covered with mist, waterfalls, and lush greenery. Villages along the route showcase traditional Maharashtrian culture. It is a hidden paradise for those who enjoy raw, untouched natural beauty."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is a well-known viewpoint offering sweeping views of the valleys and low-lying regions towards Mumbai. It is a peaceful spot often visited by tourists on their way to or from Bhimashankar. The point is ideal for photography and enjoying the fresh mountain breeze. During clear days, one can see endless stretches of hills and forests. The sunsets here are particularly captivating. It’s a great stopover for travelers seeking panoramic views of the Sahyadris."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "Bhimashankar is a hub for trekking enthusiasts with multiple trails leading through forests, rivers, and hilltops. Popular routes include the Shidi Ghat, Ganesh Ghat, and Ahupe Ghat treks. Each trail offers a unique experience of the Western Ghats’ biodiversity. Trekkers often encounter waterfalls, caves, and wildlife along the way. Monsoon season makes these trails even more thrilling with mist and flowing streams. These treks are a perfect mix of adventure, spirituality, and nature exploration."
  },
  {
    "title": "Paddar Killa (Padargad Fort)",
    "description": "Padargad Fort is a small hill fort located near Bhimashankar, popular among trekkers and history buffs. The fort is known for its steep climbs and adventurous trails. Though mostly in ruins, it offers stunning views of the Sahyadri ranges. Caves and water cisterns within the fort add to its historic charm. Trekkers enjoy the thrilling climb, especially via the rock patches and ladders. It’s a hidden gem for those who love combining history with adventure."
  },
  {
    "title": "Waterfalls of Bhimashankar",
    "description": "The region around Bhimashankar is dotted with countless waterfalls that come alive during the monsoon. These natural cascades, surrounded by thick forests, create a breathtaking atmosphere. Trekkers and nature lovers often rest near these waterfalls to enjoy their beauty. Some waterfalls are easily accessible, while others require short hikes. The sound of rushing water amidst lush greenery is refreshing for the soul. These waterfalls make Bhimashankar an enchanting monsoon destination."
  }
],


"services": [
    {
        "name": "Pune to Bhimashankar Taxi Fare",
        "description": "Get clear and affordable taxi fare estimates for your Pune to Bhimashankar trip. We offer competitive pricing with no hidden costs, covering all charges like tolls and driver allowances. Choose from a variety of vehicles based on your group size and travel preference."
    },
    {
        "name": "Pune to Bhimashankar Innova Cab Service",
        "description": "Enjoy a safe and comfortable journey to Bhimashankar with our Innova cab service from Pune. Ideal for families and groups, the cab offers spacious interiors, AC comfort, and professional drivers who ensure a smooth ride through the ghats and forest routes."
    },
    {
        "name": "Pune to Bhimashankar Innova Crysta Cab Service",
        "description": "Travel in luxury with our Innova Crysta cab service from Pune to Bhimashankar. Perfect for those seeking extra comfort on winding roads, this cab offers plush seating, ample legroom, and smooth suspension, ideal for temple visits or weekend getaways."
    },
    {
        "name": "Pune to Bhimashankar Taxi",
        "description": "Book reliable taxis from Pune to Bhimashankar for a peaceful and convenient journey. Our well-maintained vehicles and trained drivers ensure you reach the temple on time with utmost comfort, whether you're traveling alone, as a couple, or with family."
    },
    {
        "name": "Pune to Bhimashankar Cab Booking",
        "description": "Easily book cabs online from Pune to Bhimashankar with instant confirmation. Choose from hatchbacks, sedans, or SUVs based on your needs. Our service ensures timely pickup, experienced drivers, and comfortable vehicles for a stress-free temple visit."
    },
    {
        "name": "Pune to Bhimashankar Cab Package",
        "description": "Our Pune to Bhimashankar cab packages include round trip fares, driver charges, tolls, and waiting time. Enjoy a planned spiritual trip with customized stops, flexible timing, and no hidden fees. Best suited for family or group travel."
    },
    {
        "name": "Innova Crysta for Bhimashankar Trip",
        "description": "Hire an Innova Crysta for your Bhimashankar trip from Pune and experience top-level comfort on hilly terrain. With AC, reclining seats, and expert drivers, this option is ideal for pilgrims, senior citizens, and weekend travelers alike."
    },
    {
        "name": "Pune to Bhimashankar Dzire Taxi",
        "description": "Book a Swift Dzire taxi from Pune to Bhimashankar for a fuel-efficient, budget-friendly ride. This sedan is perfect for couples or small families seeking a smooth journey with AC comfort and professional drivers who know the route well."
    },
    {
        "name": "Pune to Bhimashankar Etios Cab",
        "description": "Enjoy your spiritual journey from Pune to Bhimashankar with our Etios cab service. Known for comfort and reliability, Etios is a great choice for small families or business travelers wanting a peaceful ride to the temple."
    },
    {
        "name": "Pune to Bhimashankar Family Cab",
        "description": "Make your family pilgrimage from Pune to Bhimashankar easy with our spacious family cabs. These vehicles provide enough room for passengers and luggage, AC comfort, and skilled drivers for a smooth drive through winding roads and natural landscapes."
    },
    {
        "name": "Pune to Bhimashankar Tour Package",
        "description": "Opt for a complete tour package from Pune to Bhimashankar that includes round-trip cab, sightseeing en route, driver charges, and flexible return time. Ideal for spiritual tourists and weekend explorers looking to make the most of the trip."
    },
    {
        "name": "Pune to Bhimashankar Affordable Taxi",
        "description": "Travel on a budget with our affordable taxi service from Pune to Bhimashankar. Get clean, well-maintained cars with experienced drivers at the lowest fares. Best suited for solo travelers or small families planning a quick temple visit."
    }
],
"tableData": [
    ["Pune to Bhimashankar Taxi Fare", "Pune to Bhimashankar Innova Cab Service"],
    ["Pune to Bhimashankar Innova Crysta Cab Service", "Pune to Bhimashankar Taxi"],
    ["Pune to Bhimashankar Cab Booking", "Pune to Bhimashankar Cab Package"],
    ["Innova Crysta for Bhimashankar Trip", "Pune to Bhimashankar Dzire Taxi"],
    ["Pune to Bhimashankar Etios Cab", "Pune to Bhimashankar Family Cab"],
    ["Pune to Bhimashankar Tour Package", "Pune to Bhimashankar Affordable Taxi"]
],


 "whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Bhimashankar Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable cab services from Pune to Bhimashankar, ideal for temple visits, pilgrimages, and nature getaways. We ensure punctual pickups and a smooth journey through the scenic ghats."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Equipped Vehicles",
        "WhyChoosedescription": "Our fleet includes clean, air-conditioned, and comfortable cabs suitable for individuals, families, and small groups. Enjoy a peaceful ride with ample space for luggage and relaxation."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Ghat and Forest Routes",
        "WhyChoosedescription": "Our trained drivers are experienced with the winding routes and forest areas on the way to Bhimashankar. They ensure safe driving and are familiar with the best rest stops along the way."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Itinerary",
        "WhyChoosedescription": "Choose from one-way, same-day return, or overnight trip packages as per your travel needs. Prince Cabs makes booking easy through call, website, or WhatsApp with instant confirmation."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Cabs",
        "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized before each trip. We maintain our vehicles regularly to offer a safe, hygienic, and comfortable experience for our passengers."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Get clear and upfront pricing on all Pune to Bhimashankar cab bookings. No surprises—just honest rates and multiple payment options including UPI, cards, and cash."
    },
    {
        "WhyChooseheading": "24/7 Support for a Smooth Pilgrimage Experience",
        "WhyChoosedescription": "Our support team is available round the clock to help you with your trip. Whether it's booking assistance or en-route support, we ensure a hassle-free and peaceful travel experience."
    }
]



















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Bhimashankar cab services?',
        answer: 'Yes, Prince Cabs provides reliable Pune to Bhimashankar cab services, ideal for temple visits, weekend trips, and nature getaways.',
    },
    {
        question: 'What cab options are available for the Pune to Bhimashankar route?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to cater to solo travelers, families, and groups.',
    },
    {
        question: 'Are the cabs comfortable and suitable for hilly routes like Bhimashankar?',
        answer: 'Absolutely! Our cabs are equipped with AC, clean interiors, and experienced drivers familiar with the Bhimashankar route to ensure a safe and smooth ride.',
    },
    {
        question: 'Can I plan stops or customize the route during the Pune to Bhimashankar trip?',
        answer: 'Yes, you can personalize your travel plan with stopovers, preferred pickup points, and drop-off locations to make your journey more convenient.',
    },
    {
        question: 'What are the charges for a Pune to Bhimashankar cab?',
        answer: 'Pricing varies based on the vehicle type, trip duration, and additional preferences. Contact Prince Cabs for an accurate and competitive quote.',
    },
    {
        question: 'How can I book a Pune to Bhimashankar cab with Prince Cabs?',
        answer: 'Booking is simple—just call us or visit our website with your travel details. Our team will assist you in selecting the right cab for your journey.',
    },
    {
        question: 'Are the cabs safe, clean, and regularly maintained?',
        answer: 'Yes, all our vehicles are sanitized, serviced regularly, and maintained to high standards to ensure safety and comfort on your Bhimashankar trip.',
    },
];

const testimonials = [
    {
        name: "Mr. Pravin Jadhav",
        position: "Devotee",
        text: "We booked a Pune to Bhimashankar cab with Prince Cabs for our temple visit. The driver was respectful and the cab was very clean. Great experience!",
        image: "/img/testimonial/testimonial-thumb-bhimashankar-1.png",
    },
    {
        name: "Mrs. Sneha Rane",
        position: "Weekend Traveler",
        text: "Our trip to Bhimashankar from Pune was smooth and timely, thanks to Prince Cabs. The driver knew the route well and the car was comfortable.",
        image: "/img/testimonial/testimonial-thumb-bhimashankar-2.png",
    },
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab",
  "image": "https://princecab.com/assets/images/pune-bhimashankar-cab.jpg",
  "description": "Book Pune to Bhimashankar cab with Prince Cabs – Affordable taxi fare and comfortable travel options including Dzire, Etios, Innova Crysta, and SUVs. Ideal for family tours and pilgrimages. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "6620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-bhimashankar-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Bhimashankar Cab | Affordable Temple Tour Taxi | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Bhimashankar cab booking with budget-friendly fares and verified drivers. Choose from Dzire, Etios, Innova Crysta for temple trips, family tours, and round trip packages. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Bhimashankar Taxi Fare, Pune to Bhimashankar Innova Cab Service, Pune to Bhimashankar Innova Crysta Cab Service, Pune to Bhimashankar Taxi, Pune to Bhimashankar Cab Booking, Pune to Bhimashankar Cab Package, Innova Crysta for Bhimashankar Trip, Pune to Bhimashankar Dzire Taxi, Pune to Bhimashankar Etios Cab, Pune to Bhimashankar Family Cab, Pune to Bhimashankar Tour Package, Pune to Bhimashankar Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankar;